var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('iframe',{staticClass:"iframe",attrs:{"src":'http://121.78.147.57:8000/Eple_Web/Record.action?call_date='+_vm.callDate+'&phone_number='+_vm.phoneNo+'&company_code=ueducation',"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }